export default __webpack_public_path__ + "static/media/app-logo-light.32ac4584.svg";